<template>
    <div class="data-panel">
        <div class="data-panel-header">
            <h2>{{ $t(`fixed.report.overview.title`) }}</h2>
            <div class="extra">
                <a-radio-group v-model="type" style="margin:0 0 0 16px;">
                    <a-radio-button value="daily">{{ $t(`fixed.report.overview.daily`) }}</a-radio-button>
                    <a-radio-button value="weekly">{{ $t(`fixed.report.overview.weekly`) }}</a-radio-button>
                    <a-radio-button value="monthly">{{ $t(`fixed.report.overview.monthly`) }}</a-radio-button>
                </a-radio-group>
            </div>
        </div>
        <!-- 数据概览-数据模块 -->
        <div class="data-panel-content overview-panel-content">
            <div class="data-panel-content-block overview_block data-panel-module" 
                v-for="(field, index) in fields" :key="`overview_${field.id}`"
                :class="{'selected':index==selected}" @click="selected=index"
                :style="{width:`${block_width}%`, padding: '16px 25px 16px 25px'}" 
            >
                <div class="title">{{field.title}}</div>
                <div class="day today">
                    <span class="date" v-if="type!=='weekly'">{{type=='daily'?dt?dt:$t('common.yesterdayT'):`${$t(`month.short_${month}`)}`}}</span>
                    <span class="date" v-else style="line-height: 14px">{{dt?'':$t('fixed.report.overview.lastWeek')}}<br />{{ $t('fixed.report.overview.weekCount', {'count':week}) }}</span>
                    <h2 v-if="overview.all[field.id]!=null">{{overview.all[field.id] | format(field.decimal)}}{{field.suffix}}</h2>
                    <h2 v-else class="data_computed">{{ $t('fixed.noData') }}</h2>
                </div>
                <div class="day splitday" v-if="isPC==false">
                    <div style="width:50%;float:left; position:relative">
                        <span class="date">iOS:</span>
                        <h2 v-if="overview.ios[field.id]!=null">{{overview.ios[field.id] | format(field.decimal)}}{{field.suffix}}</h2>
                        <h2 v-else class="data_computed">{{ $t('fixed.noData') }}</h2>
                    </div>
                    <div style="width:50%;float:left; position:relative">
                        <span class="date">{{ $t('fixed.androidS') }}:</span>
                        <h2 v-if="overview.ad[field.id]!=null">{{overview.ad[field.id] | format(field.decimal)}}{{field.suffix}}</h2>
                        <h2 v-else class="data_computed">{{ $t('fixed.noData') }}</h2>
                    </div>
                </div>
            </div>
            <div class="overview_block_selected" :style="{width:`${block_width}%`, left:`${selected*block_width}%`}"></div>
        </div>
        <div class="data-panel-chart open" style="height:100%;; padding-bottom:20px;">
            <div class="op_bar">
                <template v-if="display === 'table'">
                    <a-button @click="exportToExcel('overview_table', `${$service.PROJ_CODE}-${$t('fixed.report.name')}-${$t(`fixed.report.overview.${type}`)}`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                    <a-button @click="copy('overview_table')" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                </template>
                <a-date-picker class="date_picker" v-model="daily.date" :allowClear="false" :placeholder="$t('fixed.setDate')" @change="addDate($event, type)" v-if="type==='daily'"/>
                <a-select :placeholder="$t('fixed.setYear')" style="width: 180px; margin:0 8px" v-model="weekly.date" @change="addDate($event, type)" v-else-if="type==='weekly'">
                    <a-select-option v-for="i in years" :key="i">{{i}}</a-select-option>
                </a-select>
                <a-select :placeholder="$t('fixed.setYear')" style="width: 180px; margin:0 8px" v-model="monthly.date" @change="addDate($event, type)" v-else>
                    <a-select-option v-for="i in years" :key="i">{{i}}</a-select-option>
                </a-select>
                <a-button class="clear_btn" @click="clearDate(type)" style="margin:0 0 0 8px">{{ $t('common.clear') }}</a-button>
                <a-radio-group v-model="display" style="margin:0 0 0 16px;">
                    <a-radio-button value="chart">{{ $t('common.chart') }}</a-radio-button>
                    <a-radio-button value="table">{{ $t('common.table') }}</a-radio-button>
                </a-radio-group>
            </div>
            <div>
                <chart :datas="this[type].chart_datas" :conf="chart" :height="400" :fields="chart_fields" class="fixed-chart" :class="{hidepanel:display!=='chart'}"/>
                <data-table :fields="chart_fields" :datas="this[type].table_datas" ref="overview_table"  class="fixed-datatable" :class="{hidepanel:display!=='table'}"/>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"

import Server from '@/components/common/search/server.vue'
import Chart from '@/components/common/chart/chart.vue'
import DataTable from '@/components/common/datatable.vue'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js'
import {weekday, versionDurationDays, monthname, format} from '@/utils/utils'
export default {
    name: 'overviewPanel',
    mixins: [datatableMixin],
    inject: ['today', 'yesterday', 'ranges'],
    components: {
        Chart, DataTable, Server,
    },
    props: {
        // 数据接口
        api: {
            type: String,
        },
        // 标题
        title: {
            type: String,
            default: "数据概览",
        },
        // 其他配置条件
        conf: {
            type: Object,
            default: ()=>{return {}},
        },
        searchers: {
            type: Object,
            default: ()=>{return {}},
        }
    },
    data() {
        return {
            isPC: true,
            type: 'daily',
            dt: null,
            week: "",
            month: "",
            selected: 2,
            // 概览数据
            overview: {
                all: {},
                ios: {},
                ad: {},
            },
            display: 'chart',
            date_range: [],
            server: null,
            years: [],
            daily: {
                num:4,
                colors: [],
                dates: [],
                dates_num: {},
                origin_dates: [],
                table_datas: [], 
                chart_datas: [],   
            },
            weekly: {
                num:4,
                dates: [],
                dates_num: {},
                table_datas: [], 
                chart_datas: [],   
            },
            monthly: {
                num:4,
                dates: [],
                dates_num: {},
                table_datas: [], 
                chart_datas: [],   
            }
        }
    },
    watch: {
        type(newV) {
            this.getOverview()
            if(newV==='daily') {
                this.initDaily()
            }
            else if(newV==='weekly') {
                this.initWeekly()
            }
            else if(newV==='monthly') {
                this.initMonthly()
            }
        },
    },
    computed: {
        game_info() {
            return this.$store.state.game.info;
        },
        block_width() {
            return this.fields.length>0?100/this.fields.length:100
        },
        fields() {
            const t = this.type?this.type:'daily'
            return this.$service.PROJ_CODE === 'nsh'? [
                {id: 'os_cash', title:this.$t('fixed.report.overview.dataCash')},
                {id: 'os_pay_account', title:this.$t('fixed.report.overview.dataPayAccount')},
                {id: 'os_new_cnt', title:this.$t('fixed.report.overview.dataNew')},
                {id: 'os_reflow_15', title:'15日回流账号'},
                {id: `os_${t[0]}au`, title:`${t[0].toUpperCase()}AU`},
            ]: [
                {id: 'os_cash', title:this.$t('fixed.report.overview.dataCash')},
                {id: 'os_pay_account', title:this.$t('fixed.report.overview.dataPayAccount')},
                {id: 'os_new_cnt', title: this.$t('fixed.report.overview.dataNew')},
                {id: `os_${t[0]}au`, title:`${t[0].toUpperCase()}AU`},
            ]
        },
        chart_fields() {
            let header = this.type==='weekly'?[{id:'year', title:this.$t('common.yearTime'), width:'10%'}, {id:'week_id', title:this.$t('common.weekTime'), width:'10%'}]:
                this.type==='monthly'?[{id:'month_id', title:this.$t('common.monthTime'), width:'20%'}]:[{id:'dt', title:this.$t('common.date'), width:'20%'}]
            return header.concat(this.fields)     
        },
        chart() {
            let conf = this.type === 'monthly' || this.type === 'weekly'? {
                fixed: true,
                type: 'line',
                x: this.type === 'weekly'? {id: 'weekname', title: this.$t('common.weekTime'), tickCount:1}: {id: 'monthname', title: this.$t('common.date')},
                y: this.fields[this.selected],
                color: null,
                series: {id:'year'},
                label: false,
                slider: true,
                tooltip: this.type === 'weekly' ? [`start_dt*end_dt*${this.fields[this.selected].id}*${this.fields[this.selected].id}_updown`,
                    (start_dt, end_dt, y, updown) => ({ 
                        name: `${start_dt}~${end_dt}`, 
                        value: `${format(y, true)} ${(updown || updown==0)?`<span style="margin-left: 4px;color:${updown>=0?'red':'green'}">${updown==='-'?'-':updown+'%'}</span>`:''}`
                    })
                ] : null
            }: {
                fixed: true,
                versionday: 'dt',
                type: 'line',
                x: {id: 'ds', title: this.$t('common.date')},
                y: this.fields[this.selected],
                color: (series)=>{return this.daily.colors[series]},
                series: {id:'series'},
                label: false,
                slider: true,
                mark: true,
                other: {
                    legend: {
                        reversed: true,
                    }
                }
            }
            return conf
        },
    },
    methods: {
        initDate() {
            let years = []
            for(let i=2012; i<=new Date().getFullYear(); i++) {
                years.push(i)
            }
            this.years = years
            
            if(this.searchers.date_range && this.searchers.date_range.default) {
                this.date_range = [moment(this.searchers.date_range.default[0]), moment(this.searchers.date_range.default[1])]
                this.dt = this.date_range[1].format('YYYY-MM-DD')
                this.yesterday = this.date_range[1]
                this.today = this.date_range[1]
            }
        },
        // 获取数据概览数据
        getOverview() {
            if(this.api) {
                let params = {type:this.type}
                if(this.type == 'daily') {
                    params['dt'] = this.dt?this.dt:this.yesterday.format('YYYY-MM-DD');
                }
                else if(this.type == 'weekly') {
                    let week = this.dt?moment(this.dt).startOf('week').add(this.$i18n.locale==='en_US'?1:0, 'day'):moment(this.today).subtract(1, 'week').startOf('week')
                    params['week'] = week.format('YYYY-MM-DD')
                    this.week = week.week()
                }
                else if(this.type == 'monthly') {
                    let month = this.dt?moment(this.dt):moment(this.today).subtract(1, 'month')
                    params['month'] = month.format('YYYYMM');
                    this.month = month.month()+1
                }
                this.$service.query_fixed_module(this.api, params).then((data)=>{
                    this.overview = data
                    if(data.is_pc==true) {
                        this.isPC = true
                    }
                    else {
                        this.isPC = false
                    }
                })
            }
        },
        initDaily() {
            let four_week_ago = moment(this.today).subtract(27, 'day');
            let eight_week_ago = moment(this.today).subtract(55, 'day');
            let year_ago = moment(four_week_ago).subtract(1, 'year');
            let dates = [four_week_ago, eight_week_ago, ]
            let series_name = [this.$t('common.currentPeriod'), this.$t('common.monthPeriod'), ]
            let colors = ['#1890FF', '#FFAE28', '#2FC25B']  
            if(this.$service.PROJ_CODE.indexOf('l10') >= 0) {
                
                const versionDays = (this.game_info && this.game_info.new_version_days) ? this.game_info.new_version_days : {};
                const lastDuration = versionDurationDays(four_week_ago, 28, year_ago, versionDays);
                year_ago = moment(year_ago).add(lastDuration, 'day');
                dates.push(year_ago)
                series_name.push(this.$t('common.yearPeriod'))
            }
            let params = []
            for(let d_index=0; d_index<dates.length; d_index++) {
                let start_dt = dates[d_index].format('YYYY-MM-DD')
                let end_dt = moment(start_dt).add(27, 'day').format('YYYY-MM-DD');
                params.push({start_dt, end_dt})

                if(d_index > 0) {
                    series_name[d_index] = `${series_name[d_index]}(${start_dt}~${end_dt})`
                }
            }
            
            this.$service.query_fixed_module('report_overview_chart', {type:'daily', ranges:params}).then((datas) => {
                this.daily.origin_dates = dates
                for(let d_index=0; d_index<params.length; d_index++) {
                    this.setDaily(params[d_index].start_dt, params[d_index].end_dt,  series_name[d_index], datas[d_index], colors[d_index], d_index+1)
                }
            })
        },
        setDaily(start_dt, end_dt, series, data, color, num) {
            // 排序序号
            num=num?num:this.daily.num
            this.daily.num = num+1
            this.daily.dates_num[start_dt] = num
            const ocolors = ['#1890FF','#FFAE28','#2FC25B','#223273','#8543E0','#13C2C2','#3436C7','#F04864','#FFAE28','#66B5FF','#41D9C7','#2FC25B','#6EDB8F','#9AE65C','#E6965C','#57AD71','#223273','#738AE6','#7564CC','#8543E0','#A877ED','#5C8EE6','#13C2C2','#70E0E0','#5CA3E6','#3436C7','#8082FF','#DD81E6','#F04864','#FA7D92','#D598D9' ]
            if(color) {
                this.daily.colors[series] = color
            }
            else {
                this.daily.colors[series] = ocolors[num-1%ocolors.length]
            }
            const _days = []
            data.forEach((d, r_index)=>{
                d['series'] = series
                d['num'] = num
                let day = moment(this.daily.origin_dates[0]).add(d.day, 'days')
                d['ds'] = day.format('YYYY-MM-DD')
                d['weekday'] = this.$t(`week.short_${day.weekday()+1}`)
                d['dt_weekday'] = this.$t(`week.short_${moment(d['dt']).weekday()+1}`)
                
                const _fs = ['os_cash', 'os_pay', 'os_new', 'os_dau', 'os_reflow_15']
                _fs.forEach((e) => {
                    d[`${e}_updown`] = r_index > 0 ? (data[r_index-1][e] === 0 || data[r_index-1][e] == null)? '-' : Math.floor(((d[e] - data[r_index-1][e]) / data[r_index-1][e]) * 10000) / 100 : '-'
                })
                _days.push(d.day)
            })
            if(data.length > 0) {
                for(let i=0; i<28; i++) {
                    if(_days.indexOf(i)<0) {
                        const d={}
                        d['series'] = series
                        d['num'] = 0
                        let day = moment(this.daily.origin_dates[0]).add(i, 'days')
                        d['dt'] = moment(start_dt).add(i, 'days').format('YYYY-MM-DD')
                        d['ds'] = day.format('YYYY-MM-DD')
                        d['weekday'] = this.$t(`week.short_${day.weekday()+1}`)
                        d['dt_weekday'] = this.$t(`week.short_${moment(d['dt']).weekday()+1}`)
                        _days.push(d.day)
                        data.push(d)
                    }
                }
            }

            if(this.daily.dates.indexOf(start_dt) < 0) {
                this.daily.chart_datas = _.orderBy(this.daily.chart_datas.concat(data), ['num', 'dt', 'time'], ['desc', 'asc', 'asc'])
                this.daily.table_datas = this.getTableDatas(this.daily.chart_datas, 'dt')
                this.daily.dates.push(start_dt)
            }
        },
        // 获取日报图表数据
        getDaily(dt, series) {
            let start_dt = dt.format('YYYY-MM-DD')
            let end_dt = moment(start_dt).add(27, 'day').format('YYYY-MM-DD');
            this.$service.query_fixed_module('report_overview_chart', {type:'daily', start_dt, end_dt}).then((data) => {
                this.setDaily(start_dt, end_dt, `${start_dt}~${end_dt}`, data)
            })
        },
        initWeekly() {
            let this_year = null, last_year = null
            this_year = moment(this.today).subtract(1, 'week');
            let this_year_year = this_year.year()
            if(this_year.month()==11 && this_year.week()==1)
                this_year_year+=1
            let last_year_year = this_year_year-1
            this.weekly.origin_dates = [this_year_year, last_year_year]
            this.getWeekly(this_year_year, 1)
            this.getWeekly(last_year_year, 2)
        },
        // 获取周报图表数据
        getWeekly(year, default_num) {
            this.$service.query_fixed_module('report_overview_chart', {type:'weekly', year}).then((data) => {
                let num=this.weekly.num
                if(this.weekly.dates_num[year]) {
                    num = this.weekly.dates_num[year]
                }
                else {
                    if (default_num) {
                        num = default_num
                    }
                    else {
                        this.weekly.num+=1
                    }
                }
                this.weekly.dates_num[year] = num
                data.forEach((d, r_index)=>{
                    d['num'] = num
                    d['weekname'] = this.$t('fixed.report.overview.weekCount', {count:d['week_id']})
                    d['year'] = year
                    if(r_index > 0) {
                        d['os_cash_updown'] = (data[r_index-1]['os_cash']==0 || data[r_index-1]['os_cash']==null)?'-':Math.floor(((d['os_cash'] - data[r_index-1]['os_cash']) / data[r_index-1]['os_cash']) * 10000) / 100
                        d['os_pay_account_updown'] = (data[r_index-1]['os_pay_account']==0 || data[r_index-1]['os_pay_account']==null)?'-':Math.floor(((d['os_pay_account'] - data[r_index-1]['os_pay_account']) / data[r_index-1]['os_pay_account']) * 10000) / 100
                        d['os_new_cnt_updown'] = (data[r_index-1]['os_new_cnt']==0||data[r_index-1]['os_new_cnt']==null)?'-':Math.floor(((d['os_new_cnt'] - data[r_index-1]['os_new_cnt']) / data[r_index-1]['os_new_cnt']) * 10000) / 100
                        d['os_wau_updown'] = (data[r_index-1]['os_wau']==0||data[r_index-1]['os_wau']==null)?'-':Math.floor(((d['os_wau'] - data[r_index-1]['os_wau']) / data[r_index-1]['os_wau']) * 10000) / 100
                        d['os_reflow_15_updown'] = (data[r_index-1]['os_reflow_15']==0||data[r_index-1]['os_reflow_15']==null)?'-':Math.floor(((d['os_reflow_15'] - data[r_index-1]['os_reflow_15']) / data[r_index-1]['os_reflow_15']) * 10000) / 100
                    } else {
                        d['os_cash_updown'] = '-'
                        d['os_pay_account_updown'] = '-'
                        d['os_new_cnt_updown'] = '-'
                        d['os_wau_updown'] = '-'
                        d['os_reflow_15_updown'] =  '-'
                    }
                })
                if(this.weekly.dates.indexOf(year) < 0) {
                    this.weekly.chart_datas = _.orderBy(this.weekly.chart_datas.concat(data), ['num', 'week_id'], ['asc', 'asc'])
                    this.weekly.table_datas = this.getTableDatas(this.weekly.chart_datas, 'start_dt')
                    this.weekly.dates.push(year)
                }
            })
        },
        initMonthly() {
            let this_year = null, last_year = null
            if(this.today.month() == 0) {
                this_year = moment(this.today).subtract(1, 'year').year();
                last_year = moment(this.today).subtract(2, 'year').year();
            }
            else {
                this_year = this.today.year();
                last_year = moment(this.today).subtract(1, 'year').year();
            }
            this.monthly.origin_dates = [this_year, last_year]
            this.getMonthly(this_year, 1)
            this.getMonthly(last_year, 2)
        },
        // 获取日报图表数据
        getMonthly(year, default_num) {
            this.$service.query_fixed_module('report_overview_chart', {type:'monthly', year}).then((data) => {
                let num=this.monthly.num
                if(this.monthly.dates_num[year]) {
                    num = this.monthly.dates_num[year]
                }
                else {
                    if (default_num) {
                        num = default_num
                    }
                    else {
                        this.monthly.num+=1
                    }
                }
                this.monthly.dates_num[year] = num
                data.forEach((d, r_index)=>{
                    d['num'] = num
                    d['monthname'] = this.$t(`month.short_${d['month']}`)
                    if(r_index > 0) {
                        d['os_cash_updown'] = (data[r_index-1]['os_cash']==0||data[r_index-1]['os_cash']==null)?'-':Math.floor(((d['os_cash'] - data[r_index-1]['os_cash']) / data[r_index-1]['os_cash']) * 10000) / 100
                        d['os_pay_account_updown'] = (data[r_index-1]['os_pay_account']==0||data[r_index-1]['os_pay_account']==null)?'-':Math.floor(((d['os_pay_account'] - data[r_index-1]['os_pay_account']) / data[r_index-1]['os_pay_account']) * 10000) / 100
                        d['os_new_cnt_updown'] = (data[r_index-1]['os_new_cnt']==0||data[r_index-1]['os_new_cnt']==null)?'-':Math.floor(((d['os_new_cnt'] - data[r_index-1]['os_new_cnt']) / data[r_index-1]['os_new_cnt']) * 10000) / 100
                        d['os_mau_updown'] = (data[r_index-1]['os_mau']==0||data[r_index-1]['os_new_cnt']==null)?'-':Math.floor(((d['os_mau'] - data[r_index-1]['os_mau']) / data[r_index-1]['os_mau']) * 10000) / 100
                        d['os_reflow_15_updown'] = (data[r_index-1]['os_reflow_15']==0||data[r_index-1]['os_reflow_15']==null)?'-':Math.floor(((d['os_reflow_15'] - data[r_index-1]['os_reflow_15']) / data[r_index-1]['os_reflow_15']) * 10000) / 100
                    } else {
                        d['os_cash_updown'] = '-'
                        d['os_pay_account_updown'] = '-'
                        d['os_new_cnt_updown'] = '-'
                        d['os_mau_updown'] = '-'
                        d['os_reflow_15_updown'] = '-'
                    }
                })
                if(this.monthly.dates.indexOf(year) < 0) {
                    this.monthly.dates.push(year)
                    this.monthly.chart_datas = _.orderBy(this.monthly.chart_datas.concat(data), ['num', 'year', 'month'], ['asc', 'asc', 'asc'])
                    this.monthly.table_datas = this.getTableDatas(this.monthly.chart_datas, 'month_id')
                }
            })
        },
        // 选择月报对比日期
        addDate(dateString, type) {
            let self = this[type]
            if(self.dates.indexOf(dateString) < 0) {
                if(type==='daily') {
                    this.getDaily(dateString)
                }
                else if(type==='weekly') {
                    this.getWeekly(dateString)
                }
                else if(type==='monthly') {
                    this.getMonthly(dateString)
                }
            }
        },
        clearDate(type) {
            let self = this[type]
            let datas = []
            if(type==='daily') {
                self.chart_datas.forEach((d)=>{
                    if(d.series == this.$t('common.currentPeriod') || d.series.indexOf(this.$t('common.monthPeriod'))>=0 || d.series.indexOf(this.$t('common.yearPeriod'))>=0) {
                        datas.push(d)
                    }
                })
            }
            else {
                self.chart_datas.forEach((d)=>{
                    if(self.origin_dates.indexOf(d.year)>=0) {
                        datas.push(d)
                    }
                })
            }
            
            self.date = undefined
            self.dates_num = {}
            self.dates = _.cloneDeep(self.origin_dates)
            self.chart_datas = datas
            self.table_datas = this.getTableDatas(self.chart_datas, type==='daily'?'dt':type==='weekly'?'start_dt':'month_id')
        },
        getTableDatas(datas, field) {
            let combine_dates = {}
            let combine_datas = []
            datas.forEach((row)=> {
                if(!combine_dates[row[field]]) {
                    combine_dates[row[field]] = 1
                    combine_datas.push(row)
                }
            })
            return _.orderBy(combine_datas, [field], ['desc'])
        },
    },
    mounted() {
        this.initDate()
        this.getOverview()
        this.initDaily()
    }
}
</script>